var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[(_vm.isNavbarVisible)?_c('el-aside',{attrs:{"width":"180px"}},[_c('navbar')],1):_vm._e(),_c('el-container',[_c('el-header',[_c('Header')],1),_c('el-main',[_c('app-main')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }